import React from 'react';
import './header.css';
import logo from '../assets/logo512.png';
import logosvg from '../assets/logo-any.svg'
import logoBlue from '../assets/logo-blue.svg'
import { Link } from 'react-router-dom';
import menublack from "../assets/menu-black.svg";
import menuCloseBlack from "../assets/menu-close-black.svg";
import {LinkButton} from "./link-button";

// Pentru varianta albastra, trebuie sa dau version="blue" ca si prop la Header
class Header extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            sideMenuOpen: false,
            backgroundCssClass: props.version === "blue" ? "primary-color" : "background-white",
            logoCssClass: props.version === "blue" ? "primary-color-txt" : "white-color-txt",
            menuItemClass: props.version === "blue" ? "menu-item-blue" : "menu-item",
            logoSrc: props.version === "blue" ? logoBlue : logosvg
        }
    }

    isActive(headerItem) {
        return window.location.href.indexOf(headerItem) !== -1;
    }

    toggleSideMenu() {
        this.setState({sideMenuOpen: !this.state.sideMenuOpen});
    }

    render() {
        return (
            <>
                <div id='header' className={`${this.state.backgroundCssClass} ${this.props.className || ''}`}>
                    <div className='flex-row flex-vertical-center pointer logo-group '>
                        { window.innerWidth < 600 && <Link to="/"><img id="header-logo" alt="company-logo" src={logo} /></Link> }

                        { window.innerWidth >= 600 && <Link to="/"><img id="header-logo" alt="company-logo" src={this.state.logoSrc}/></Link> }
                    </div>
                    <div className='menu'>
                        <Link to="/services"><div className={`${this.state.menuItemClass} b3 ${ this.isActive("services") ? "active-header-item": "" }`}>SERVICES</div></Link>
                        <Link to="/tehnologies"><div className={`${this.state.menuItemClass} b3 ${ this.isActive("tehnologies") ? "active-header-item": "" }`}>TEHNOLOGIES</div></Link>
                        <Link to="/case-studies"><div className={`${this.state.menuItemClass} b3 ${ this.isActive("case-studies") ? "active-header-item": "" }`}>PROJECTS</div></Link>
                        <Link to="/deep-dives"><div className={`${this.state.menuItemClass} b3 ${ this.isActive("deep-dives") ? "active-header-item": "" }`}>DEEP DIVES</div></Link>

                        <LinkButton to="/get-in-touch" text="GET IN TOUCH" className="black-back get-in-touch-black white-color-txt" />
                    </div>
                </div>


                <div id='header-mobile'>
                    <Link className='place-center' to="/">
                        <img className='side-menu-logo' alt="company-logo" src={logosvg} />
                    </Link>

                    {!this.state.sideMenuOpen && <img src={menublack} className='side-menu-btn' onClick={() => this.toggleSideMenu()} alt="menu-btn" /> }

                    { this.state.sideMenuOpen && <img id='close-side-menu' alt='cross button' src={menuCloseBlack} onClick={() => this.toggleSideMenu()} /> }
                </div>

                {/*{ this.state.sideMenuOpen && <label className="menu-overlay"  onClick={() => this.toggleSideMenu()}></label>}*/}

                { this.state.sideMenuOpen && <div className='side-menu-overlay' >
                    <div className='side-menu-content white'>

                        <Link to="/services"><div className={`menu-item b3 ${ this.isActive("services") ? "active-header-item": "" }`}>SERVICES</div></Link>
                        <Link to="/tehnologies"><div className={`menu-item b3 ${ this.isActive("tehnologies") ? "active-header-item": "" }`}>TEHNOLOGIES</div></Link>
                        <Link to="/case-studies"><div className={`menu-item  b3 ${ this.isActive("case-studies") ? "active-header-item": "" }`}>PROJECTS</div></Link>
                        <Link to="/deep-dives"><div className={`menu-item b3 ${ this.isActive("deep-dives") ? "active-header-item": "" }`}>DEEP DIVES</div></Link>
                        {/*<Link to="/get-in-touch"><div id="get-in-touch" className={`primary-color menu-item b3 white-color-txt ${ this.isActive("get-in-touch") ? "active-header-item": "" }`}>GET IN TOUCH</div></Link>*/}

                        <LinkButton to="/get-in-touch" text="GET IN TOUCH" className="black-back get-in-touch-black white-color-txt" />
                    </div>
                </div>}
            </>
        )
    }
}

export default Header;